$ = require 'jquery'

module.exports = (el) ->
